import "./Welcome.scss";
import NameForm from "./NameForm";

const Welcome = () => {
  return (
    <div className="welcome">
      <NameForm />
    </div>
  );
};

export default Welcome;
